import React from 'react';

const ProofOfDeliveryTableComponentLoadable = React.lazy(() => import('./ProofOfDeliveryTableComponent'));
const ProofOfBookingComponentLoadable = React.lazy(() => import('./ProofofBookingComponent'));

export {
    ProofOfDeliveryTableComponentLoadable,
    ProofOfBookingComponentLoadable
};
